import { AllocationHistory } from "types/AllocationHistory";
import { ActionType, getType } from "typesafe-actions";
import * as allocationHistoryActions from "./allocationHistoryActions";

export type AllocationHistoryState = {
  [K in allocationHistoryActions.AllocationHistoryContentType]?: {
    loading?: boolean;
    data?: AllocationHistory[];
    error?: string;
  };
};

export type AllocationHistoryActions = ActionType<typeof allocationHistoryActions>;

export default function allocationHistory(
  state: AllocationHistoryState = {},
  action: AllocationHistoryActions
) {
  switch (action.type) {
    case getType(allocationHistoryActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(allocationHistoryActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(allocationHistoryActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
